/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Vue, Component } from 'vue-property-decorator';
import { makeTracker } from '@/lib/tracker';
import { getJWT } from '@/lib/util';
export interface IProductionConfig {
  production_id: number;
  production_type: string;
  actual_price: number;
}
export interface IRes {
  el: HTMLElement;
  title: string;
}

interface ISignUp {
  button_name?: string;
}
let resList: IRes[] = [];
let scrollContainer: HTMLElement | null = null;
let containerHeight = 0;
function getModuleTitle(scrollTop: number) {
  for (const item of resList) {
    const s = item.el.offsetTop;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const e = s + item.el.offsetHeight + containerHeight / 2;
    if (s < scrollTop && scrollTop < e) {
      return item.title;
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return (resList[0] && resList[0].title) || '';
}
@Component
export default class FlashTrackMixin extends Vue {
  tracker = (event: string, payload: any) => {
    console.log('ok');
  };
  __track_config: IProductionConfig = {} as any;
  __initModelPageTrack() {
    this.tracker = makeTracker();
    this.tracker('PageView', {
      ...this.modelPageTrackInfo,
    });
  }
  __modelPageTrackScrollPageview() {
    this.tracker('PageView', {
      ...this.modelPageTrackInfo,
    });
  }
  __modelPageButtonClickTrack(isSignUp = false) {
    const signUpTrack: ISignUp = {};
    if (isSignUp) {
      signUpTrack.button_name = '立即报名';
    }
    this.tracker('ButtonClick', {
      ...this.modelPageTrackInfo,
      ...signUpTrack,
    });
  }
  __initTrack({
    user_types = '体验课用户',
    wxapp_name = '闪光编程',
    config,
  }: {
    user_types: string;
    wxapp_name: string;
    config: IProductionConfig;
  }) {
    this.tracker = makeTracker({
      tracking_scene: window.location.hash.includes('single')
        ? 'single'
        : 'group', // single || group
      user_types,
      wxapp_name,
      from: this.$route.query.From || 'unknown',
      from_version: this.$route.query.FromVersion || 'unknown',
      userid_: getJWT()?.id || 0,
      _cc: this.$route.query._cc || 'unknown',
    });
    this.__track_config = config;
    this.tracker('PageView', {
      tracking_subscene: document.title || 'unknown', // 当前页面title
      ...this.__track_config,
    });
  }
  __initTrackResList(res: IRes[]) {
    resList = res;
    scrollContainer = document.getElementById('t-scroll-container');
    if (scrollContainer) {
      containerHeight = scrollContainer.offsetHeight;
    }
  }
  __trackBtnClick(btnInfo: { button_name: string; [key: string]: any }) {
    this.tracker('ButtonClick', { ...btnInfo, button_type: '普通按钮' });
  }
  __trackApplyClick(paylaod: { button_name: string; [key: string]: any }) {
    this.tracker('ButtonClick', {
      tracking_subscene: '调起支付',
      button_type: '普通按钮',
      ...this.__track_config,
      ...paylaod,
    });
  }
  __trackScrollPageview(start: number, end: number) {
    this.tracker('PageView', {
      tracking_subscene: document.title,
      module: getModuleTitle(end),
    });
  }
  __trackBtnLeave(payload: any = {}) {
    this.tracker('ButtonClick', {
      tracking_subscene: document.title,
      button_type: '普通按钮',
      module: getModuleTitle(
        (scrollContainer && scrollContainer.scrollTop) || 0
      ),
      ...payload,
    });
  }
}
